// extracted by mini-css-extract-plugin
export default {"pageLayout":"sb-z","mainContent":"tb-z","columnLayout":"ub-z","columnLayoutFill":"vb-z","columnLayoutLast":"wb-z"};